import { Link } from 'react-router-dom';
import { Logo } from '../components/ui/Logo.js';
import { Icon } from '../components/ui/Icon.js';
import { Button } from '../components/ui/Button.js';

export function ForgotPasswordPage() {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-12"
      style={{
        background: 'var(--bg-deep)',
        backgroundImage: 'radial-gradient(60% 40% at 50% 0%, var(--accent-soft), transparent 70%)',
      }}
    >
      <div
        className="w-full max-w-md p-8 sm:p-10"
        style={{
          background: 'var(--surface)',
          borderRadius: 22,
          border: '1px solid var(--line-soft)',
          boxShadow: 'var(--shadow-card)',
        }}
      >
        <div className="flex items-center justify-between mb-8">
          <Logo />
          <Link
            to="/login"
            className="text-xs font-mono hover:underline inline-flex items-center gap-1.5"
            style={{ color: 'var(--ink-4)' }}
          >
            <Icon name="chev" size={11} style={{ transform: 'rotate(180deg)' }} />
            sign in
          </Link>
        </div>

        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              background: 'var(--accent-soft)',
              color: 'var(--accent)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 20,
              boxShadow: '0 0 60px var(--accent-glow)',
            }}
          >
            <Icon name="shield" size={32} stroke={1.8} />
          </div>

          <div
            style={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: 'var(--accent)',
              marginBottom: 10,
            }}
          >
            Account recovery
          </div>
          <h1 className="h-display" style={{ fontSize: 32, lineHeight: 1.05, margin: 0, color: 'var(--ink)' }}>
            Reset your{' '}
            <span style={{ color: 'var(--accent)', fontStyle: 'italic', fontWeight: 400 }}>access.</span>
          </h1>
          <p className="text-sm mt-3 mb-7" style={{ color: 'var(--ink-3)', maxWidth: 360, margin: '12px auto 28px', lineHeight: 1.55 }}>
            Email-based password reset is coming soon. In the meantime, reach out and we'll get you back in.
          </p>

          <div
            style={{
              background: 'var(--surface-2)',
              border: '1px solid var(--line-soft)',
              borderRadius: 14,
              padding: '14px 18px',
              marginBottom: 24,
              fontSize: 13,
              color: 'var(--ink-2)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Icon name="bell" size={15} style={{ color: 'var(--accent)' }} />
            <span>
              Email{' '}
              <a
                href="mailto:support@platterplan.com"
                style={{ color: 'var(--accent)', fontWeight: 500 }}
                className="hover:underline"
              >
                support@platterplan.com
              </a>
            </span>
          </div>

          <Link to="/login" style={{ display: 'inline-block' }}>
            <Button variant="ghost">
              <Icon name="chev" size={12} style={{ transform: 'rotate(180deg)' }} />
              Back to sign in
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
